var partialListUtils = require('./../utils/partialListUtils');
var TorsoView = require('backbone-torso/modules/View');
var applicationUtils = require('./../applicationUtils');
var AppointmentDataBehavior = require('./../appointment/AppointmentDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var onsiteDetailsTemplate = require('./onsiteDetailsTemplate.hbs');
var eregWorkflowConfigService = require('./../wizard/eregWorkflowConfigService');
var userService = require('./../user/userService');

/**
 * View for Onsite Details
 *
 * @class OnsiteDetailsView
 */
var OnsiteDetailsView = TorsoView.extend({
  template: onsiteDetailsTemplate,

  events: {
    'click [data-complete]': '_clearEregSession'
  },

  behaviors: {
    appointment: {
      behavior: AppointmentDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: {property: '_appointmentExternalId'},
      alwaysFetch: true
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      ids: {property: 'behaviors.appointment.data:externalAppointment.type'}
    },
    appointments: {
      behavior: AppointmentDataBehavior,
      renderOnFetch: true,
      updateEvents: 'viewState:change:criteria',
      ids: function(cache) {
        var criteria = this.view.get('criteria');
        if (!criteria) {
          return { skipObjectRetrieval: true };
        }
        return cache.fetchIdsByCriteria(criteria)
            .then(partialListUtils.convertPartialListResponseToList);
      },
      alwaysFetch: true
    }
  },

  prepareFields: {
    isExpressCheckin: '_isExpressCheckin',
    logoutUrl: applicationUtils.APPLICATIONS.EREG.logoutUrl,
    appointmentTypeName: function() {
      return this.getBehavior('appointmentType').data.get('displayName') || this.getBehavior('appointment').data.get('externalAppointment.type');
    }
  },

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient.
   *   @param options.appointmentExternalId {String} the vecna id of the appointment.
   *   @param options.isExpressCheckin {Boolean} whether or not this view is for express checkin.
   * @override
   */
  initialize: function(options) {
    options = options || {};
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._isExpressCheckin = options.isExpressCheckin;

    var view = this;
    userService.currentVisitModel.fetch()
        .then(function() {
          view._updateCriteria();
        });
  },

  _updateCriteria: function() {
    if (this._isExpressCheckin) {
      var criteria = {};
      criteria.checkedIn = true;
      criteria.cancelled = false;
      criteria.preregistered = true;
      criteria.patientVecnaIds = [this._patientVecnaId];
      criteria.externalIds = userService.currentVisitModel.get('retrievedAppointmentExternalIds');
      this.set('criteria', criteria);
    }
  },

  /**
   * Clears the ereg session before redirecting so that when the user logs in again they are not stuck with the old config.
   * @method _clearEregSession
   * @private
   */
  _clearEregSession: function() {
    eregWorkflowConfigService.removeEregWorkflowConfig();
  }
});

module.exports = OnsiteDetailsView;
